import { OutlinedInput, InputLabel, Select, Checkbox, ListItemText, MenuItem, FormControl } from '@mui/material';
import React from 'react';
import { Box, Chip } from '@material-ui/core';

const MultipleSelect = ({ id, label, handleChange, value, options }) => {
  const handleChangeLocal = (e) => {
    const {
      target: { value },
    } = e;
    handleChange(typeof value === 'string' ? value.split(',') : value);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id={id}>{label}</InputLabel>
        <Select
          margin='dense'
          labelId={id}
          id={`label-${id}`}
          value={value}
          onChange={handleChangeLocal}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={options.filter(option => option.value === value)[0].label} size="small" />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
          multiple
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox checked={value.indexOf(option.value) > -1} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultipleSelect;
